import * as React from 'react';
import { Button, Card, Col, Divider, Modal, notification, Row, Table, Alert } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';

import AvailabilitiesQuery from '../../components/Query/Availabilities';
import AvailabilityDetail from './AvailabilityDetail';
import { Title } from '../../components/Layout/components';
import NotFoundPage from '../NotFound/NotFound';

interface IAvailabilitiesTableProps extends RouteComponentProps {
  domain: string;
  availabilityId?: string;
}

interface IAvailabilitiesTableState {
}

class AvailabilitiesTable extends React.Component<IAvailabilitiesTableProps, IAvailabilitiesTableState> {

  constructor(props: IAvailabilitiesTableProps) {
    super(props);
  }

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <AvailabilitiesQuery
            domain={this.props.domain}
          >
            {({ availabilities, deleteAvailability, createAvailability, updateAvailability }: any) => {
              return this.renderData(
                availabilities,
                updateAvailability,
                createAvailability,
                deleteAvailability,
                availabilities.refetch
              );
            }}
          </AvailabilitiesQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    availabilities: any,
    updateAvailability: Function,
    createAvailability: Function,
    deleteAvailability: Function,
    refetch: Function
  ) {
    if (availabilities && !availabilities.loading) {

      // formulář
      if (this.props && this.props.availabilityId) {
        const selectedAvailability = availabilities.availabilities.find((d: GQL.IAvailability) => d.id === this.props.availabilityId) || undefined;
        if (this.props.availabilityId !== 'new' && !selectedAvailability) {
          return <NotFoundPage domain={this.props.domain} />
        }
        return (
          <AvailabilityDetail
            domain={this.props.domain}
            languages={availabilities.languages}
            availability={availabilities.availabilities.find((s: GQL.IAvailability) => s.id === this.props.availabilityId) || undefined}
            onSave={a => this.upsert(a, updateAvailability, createAvailability, refetch)}
            onCancel={() => this.cancel()}
          />
        );
      }

      // kontrola výchozího stavu
      const defaultState = availabilities.availabilities.find((d: GQL.IAvailability) => d.default === true);

      return (
        <div>
          <Title>Availabilities</Title>
          {!defaultState &&
            <Alert message="default availability state not defined!" type="error" />}
          <Divider />
          <Link className="ant-btn" to={this.getLink('new')}>Create new availability</Link>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={availabilities.availabilities}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column
              title="Name"
              render={(row: GQL.IAvailability) => {
                const availabilityTitle = row.title ? row.title.en : '-';
                return <>{availabilityTitle} <span style={{ color: '#d0d0d0' }}>{row.name}</span></>;
              }}
            />
            <Table.Column
              title="Default"
              dataIndex="default"
              key="default"
              width={100}
              align="center"
              render={(u, row: GQL.IAvailability) => {
                return (
                  <span>
                    {row.default 
                      ? <CheckOutlined style={{ color: '#52c41a', fontSize: 20 }} />
                      : <CloseOutlined style={{ fontSize: 20 }} />}
                  </span>
                );
              }}
            />
            <Table.Column
              title="Actions"
              dataIndex="actions"
              key="actions"
              width={180}
              align="center"
              render={(u: any, row: any) => this.renderActions(u, row, deleteAvailability, refetch)}
            />
          </Table>
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading availabilities ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(u: any, availability: GQL.IAvailability, deleteAvailability: Function, refetch: Function) {
    return (
      <div>
        <Link className="ant-btn" type={'dashed'} to={this.getLink(availability.id)}>
          Edit
        </Link>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(availability, deleteAvailability, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private delete(availability: GQL.IAvailability, deleteAvailability: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${availability.name}?`,
      content: (
        <span>
          Are you sure you want to delete availability <strong>{availability.name}</strong>?
                </span>
      ),
      onOk: () => {
        return deleteAvailability({
          variables: {
            id: availability.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    availability: GQL.IAvailability,
    updateAvailability: Function,
    createAvailability: Function,
    refetch: Function
  ) {
    if (availability != undefined) {
      const variables = {
        id: availability.id,
        availability: {
          title: availability.title,
          name: availability.name,
          color: availability.color,
          default: availability.default || false,
          watchDogAction: availability.watchDogAction || null,
          allowedActions: availability.allowedActions || null,
          schemaOrg: availability.schemaOrg || null,
          excludeFromSitemap: 'boolean' === typeof availability.excludeFromSitemap ? availability.excludeFromSitemap : null,
        }
      };

      if (availability.id) {
        return updateAvailability({ variables })
          .then(() => refetch())
          .then(() => this.cancel())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Availability "${variables.availability.name}" has been updated.`
            })
          );
      }

      createAvailability({ variables })
        .then(() => refetch())
        .then(() => this.cancel())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Availability "${variables.availability.name}" has been created.`
          })
        );
    }
  }

  private getLink(recordId: string | null) {
    return `/${this.props.domain}/application/${recordId ? `availabilities/${recordId}` : 'availabilities'}`;
  }

  private cancel() {
    this.props.history.push(this.getLink(null));
  }
}

export default withRouter(AvailabilitiesTable);



// WEBPACK FOOTER //
// ./src/scenes/Availabilities/AvailabilitiesTable.tsx